import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram, Facebook } from 'lucide-react';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer className="border-t border-white/10 bg-primary-950 pb-8 pt-16 text-white">
      <div className="section-container">
        <div className="mb-16 grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-3">
          {/* Company Info */}
          <div className="space-y-6">
            <Link to="/" className="block" aria-label="DKSN Business Solutions — home">
              <Logo />
            </Link>
            <p className="max-w-xs text-gray-400">
              Transforming businesses through innovative solutions and strategic thinking.
            </p>
            <div className="flex gap-3">
              <a
                href="https://instagram.com/dksnbsolutions"
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-full border border-white/10 p-2.5 text-gray-400 transition-colors hover:border-azure-400 hover:text-azure-400"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="https://facebook.com/dksnbsolutions"
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-full border border-white/10 p-2.5 text-gray-400 transition-colors hover:border-azure-400 hover:text-azure-400"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href="https://tiktok.com/@dksnbsolutions"
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-full border border-white/10 p-2.5 text-gray-400 transition-colors hover:border-azure-400 hover:text-azure-400"
                aria-label="TikTok"
              >
                <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="eyebrow mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {[
                { to: '/about', label: 'About Us' },
                { to: '/services', label: 'Services' },
                { to: '/our-work', label: 'Our Work' },
                { to: '/contact', label: 'Contact' },
              ].map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="link-underline text-gray-400 transition-colors hover:text-white">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="eyebrow mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-gray-400">
                <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-azure-400" />
                <span>Shop 23B, Mall of Mthatha, 33 Errol Spring Ave, Umtata Part 1, Mthatha, 5099</span>
              </li>
              <li>
                <a
                  href="tel:+27679210514"
                  className="flex items-center gap-3 text-gray-400 transition-colors hover:text-white"
                >
                  <Phone className="h-5 w-5 shrink-0 text-azure-400" />
                  <span>+27 67 921 0514</span>
                </a>
              </li>
              <li>
                <a
                  href="mailto:sales@dksnbsolutions.co.za"
                  className="flex items-center gap-3 text-gray-400 transition-colors hover:text-white"
                >
                  <Mail className="h-5 w-5 shrink-0 text-azure-400" />
                  <span className="break-all">sales@dksnbsolutions.co.za</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/10 pt-8">
          <p className="text-center text-sm text-gray-400">
            © {new Date().getFullYear()} DKSN Business Solutions. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
